<div 
    class="fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-20 gap-4"
    (click)="$event.preventDefault(); closeEdit();"
>
    <div class="flex flex-row gap-1 justify-center" (click)="$event.stopPropagation()">
        <!-- EVENT DETAILS -->
        <div class="flex min-w-full bg-white p-10 w-1/4 rounded-md text-center shadow-lg">
            <form 
                (ngSubmit)="$event.preventDefault(); onSubmit();"
                [formGroup]="functionForm"
                class="w-full flex flex-col items-center justify-start gap-4"
            >
                <div class="w-full flex flex-row gap-8 items-center justify-between pb-4 border-b border-gray-200">
                    <h2 class="w-full oswald-font text-xl font-medium text-start whitespace-nowrap text-nside-orange-400">
                        Edit Function
                    </h2>                    
                    <button
                        class="p-1 rounded-full hover:bg-gray-100"
                        (click)="$event.preventDefault(); closeEdit();"
                    >
                        <lucide-icon [name]="icons.X" [size]="20" class="text-nside-gray-200"></lucide-icon>
                    </button>
                </div>
                <div class="w-full h-full flex flex-col items-center gap-2 pb-4 border-b border-gray-200">
                    <div class="w-full flex items-center text-start">
                        <div class="w-32 flex items-center text-nside-gray-300">
                            <p>Function Name:</p>
                        </div>
                        <div class="w-96 flex flex-col items-center">
                            <input noEmoji 
                                type="text"
                                formControlName="function_name"
                                class="w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block p-2"
                                placeholder="E.g., Fire"
                                required
                            >
                            <div
                                class="w-full text-start italic text-xs text-red-500" 
                                *ngIf="functionForm.get('function_name')?.invalid && (functionForm.get('function_name')?.touched || functionForm.get('function_name')?.dirty)"
                            >
                                <div *ngIf="functionForm.get('function_name')?.hasError('required')">
                                    This field is required.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="w-32 flex items-center text-nside-gray-300">
                            <p>Goal Before:</p>
                        </div>
                        <div class="w-96 flex items-center">
                            <textarea noEmoji
                                formControlName="goal_before_description"
                                rows="1" 
                                class="bg-gray-50 p-2 w-full text-sm text-gray-900 rounded border border-gray-300" 
                                placeholder="Type here..."></textarea>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="ps-2 w-32 flex items-center text-nside-gray-300 gap-1">
                            <div class="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-corner-down-right"><polyline points="15 10 20 15 15 20"/><path d="M4 4v7a4 4 0 0 0 4 4h12"/></svg>
                                <!-- <lucide-icon [name]="icons.CornerDownRight" [size]=24></lucide-icon> -->
                            </div>
                            <p>Objectives:</p>
                        </div>
                        <div class="w-96 flex items-center">
                            <textarea noEmoji
                                formControlName="goal_before_objective" 
                                rows="3" 
                                class="bg-gray-50 p-2 w-full text-sm text-gray-900 rounded border border-gray-300" 
                                placeholder="Type here..."></textarea>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="w-32 flex items-center text-nside-gray-300">
                            <p>Goal During:</p>
                        </div>
                        <div class="w-96 flex items-center">
                            <textarea noEmoji 
                                formControlName="goal_during_description" 
                                rows="1" 
                                class="bg-gray-50 p-2 w-full text-sm text-gray-900 rounded border border-gray-300" 
                                placeholder="Type here..."></textarea>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="ps-2 w-32 flex items-center text-nside-gray-300 gap-1">
                            <div class="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-corner-down-right"><polyline points="15 10 20 15 15 20"/><path d="M4 4v7a4 4 0 0 0 4 4h12"/></svg>
                                <!-- <lucide-icon [name]="icons.CornerDownRight" [size]=24></lucide-icon> -->
                            </div>
                            <p>Objectives:</p>
                        </div>
                        <div class="w-96 flex items-center">
                            <textarea noEmoji 
                                formControlName="goal_during_objective" 
                                rows="3" 
                                class="bg-gray-50 p-2 w-full text-sm text-gray-900 rounded border border-gray-300" 
                                placeholder="Type here..."></textarea>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="w-32 flex items-center text-nside-gray-300">
                            <p>Goal After:</p>
                        </div>
                        <div class="w-96 flex items-center">
                            <textarea noEmoji
                                formControlName="goal_after_description"  
                                rows="1" 
                                class="bg-gray-50 p-2 w-full text-sm text-gray-900 rounded border border-gray-300" 
                                placeholder="Type here..."></textarea>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="ps-2 w-32 flex items-center text-nside-gray-300 gap-1">
                            <div class="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-corner-down-right"><polyline points="15 10 20 15 15 20"/><path d="M4 4v7a4 4 0 0 0 4 4h12"/></svg>
                                <!-- <lucide-icon [name]="icons.CornerDownRight" [size]=24></lucide-icon> -->
                            </div>
                            <p>Objectives:</p>
                        </div>
                        <div class="w-96 flex items-center">
                            <textarea noEmoji 
                                formControlName="goal_after_objective" 
                                rows="3" 
                                class="bg-gray-50 p-2 w-full text-sm text-gray-900 rounded border border-gray-300" 
                                placeholder="Type here..."></textarea>
                        </div>
                    </div>
                </div>

                <div class="w-full flex flex-row gap-2 items-center justify-end">
                    <button 
                        (click)="$event.preventDefault(); closeEdit();"
                        class="px-4 py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font"
                    >
                        Close
                    </button>
                    <button
                        type="submit"
                        class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                        [ngClass]="{
                            'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed':
                              functionForm.invalid || !functionForm.dirty,
                            'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200':
                              functionForm.valid && functionForm.dirty
                        }"
                        [disabled]="functionForm.invalid || !functionForm.dirty"
                    >
                        Save
                    </button>
                </div>
            </form>
        </div>
        
    </div>
</div>

<div *ngIf="loading">
    <spinner></spinner>
</div>